import { useMemo } from "react";

/* Petit feu d'artifice de confettis, en CSS pur — pas de librairie externe à
   installer. Se pose en plein écran, ne bloque aucun clic (pointer-events:
   none), et se termine tout seul après ~2-3 secondes sans qu'il soit besoin
   de le démonter manuellement. */
const COLORS = ["#F59E0B", "#16A34A", "#4F46E5", "#DB2777", "#0EA5E9", "#EF4444"];

export default function ConfettiBurst({ count = 70 }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.25,
        duration: 1.6 + Math.random() * 1.3,
        color: COLORS[i % COLORS.length],
        width: 5 + Math.random() * 5,
        height: 8 + Math.random() * 6,
        drift: (Math.random() - 0.5) * 180,
        spin: 360 + Math.random() * 360,
      })),
    [count],
  );

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[100] overflow-hidden"
    >
      <style>{`
        @keyframes harf-confetti-fall {
          0%   { transform: translate(0, -10vh) rotate(0deg); opacity: 1; }
          100% { transform: translate(var(--harf-drift), 110vh) rotate(var(--harf-spin)); opacity: 0.85; }
        }
      `}</style>
      {pieces.map((p) => (
        <span
          key={p.id}
          style={{
            position: "absolute",
            left: `${p.left}%`,
            top: "-8%",
            width: p.width,
            height: p.height,
            background: p.color,
            borderRadius: 2,
            "--harf-drift": `${p.drift}px`,
            "--harf-spin": `${p.spin}deg`,
            animation: `harf-confetti-fall ${p.duration}s cubic-bezier(0.2, 0.6, 0.4, 1) ${p.delay}s forwards`,
          }}
        />
      ))}
    </div>
  );
}
